import { Box, Text } from "@mantine/core"

interface IProps {
  label: string
  value: React.ReactNode
}

export function DataLine(props: IProps) {
  const { label, value } = props
  return (
    <Box>
      <Text span color="gray" mr="lg">
        {label}
      </Text>
      <Text span fz="lg" fw={500}>
        {value}
      </Text>
    </Box>
  )
}
